import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@hub-env/environment';
import { FaroObservabilityService } from './faro-observability.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {

  // RegEx to detect errors like "ChunkLoadError: Loading chunk 166 failed."
  private chunkFailedMessage = /Loading chunk [\d]+ failed/;

  constructor(private faro: FaroObservabilityService) { }

  handleError(err: any): void {

    if (!environment.production || this.isElectron()) {
      console.log('Error: ', err, err.originalError);
      return;
    }

    if (this.chunkFailedMessage.test(err.originalError || err)) {
      window.location.reload();
    } else {
      this.faro.pushError(err.originalError || err, { source: 'global_error_handler' });
    }

  }

  // GitLab pipelines runs in Electron, we don't need these errors
  private isElectron(): boolean {

    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && (window.process as { type?: string }).type === 'renderer') {
      return true;
    }

    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
    }

    return false;

  }
}
